module.exports = __webpack_public_path__ + "img/privacy-policy.a0ee73a5.svg";